/**
 * LOGGER SEGURO PARA PRODUCCIÓN
 * 
 * Funciones de logging que solo funcionan en desarrollo.
 * En producción, los logs no aparecen en la consola del navegador.
 */

const isDevelopment = process.env.NODE_ENV === 'development';

const logger = {
  log: (...args) => {
    if (isDevelopment) {
      console.log(...args);
    }
  },
  info: (...args) => {
    if (isDevelopment) {
      console.info(...args);
    }
  },
  warn: (...args) => {
    if (isDevelopment) {
      console.warn(...args);
    }
  },
  error: (...args) => {
    // Los errores siempre se loguean, pero sin detalles sensibles en producción
    if (isDevelopment) {
      console.error(...args);
    } else {
      // En producción, solo loguear el mensaje básico sin stack traces
      const message = args[0] || 'Error';
      console.error(message);
    }
  },
  debug: (...args) => {
    if (isDevelopment) {
      console.debug(...args);
    }
  }
};

export default logger;
export const { log, info, warn, debug } = logger;
/** Usar `logError` en lugar de `error` para no sombrear `catch (error)`. */
export const logError = logger.error.bind(logger);

